<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Product Description"
      @click.native.stop
    >
      <v-select
        v-model="fileTypeFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="productOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>
    <b-form-group
      label="Receipt Status"
      @click.native.stop
    >
      <v-select
        v-model="receiptStatusFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="receiptStatusOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>
    <b-form-group
      label="Payment Mode"
      @click.native.stop
    >
      <v-select
        v-model="paymentModeFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="paymentModeOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>
    <b-form-group
      label="Transaction Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="trxDateFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <!-- <b-form-group
      label="Customer"
      @click.native.stop
    >
      <vue-autosuggest
        ref="autocomplete"
        v-model="query"
        class="customer-autosuggest"
        :suggestions="suggestions"
        :input-props="inputProps"
        :get-suggestion-value="getSuggestionValue"
        @selected="setCustomer"
        @input="fetchResults"
      >
        <template slot-scope="{suggestion}">
          <span class="my-suggestion-item text-primary">{{ suggestion.item.name }}</span>
          <br>
          <span>{{ suggestion.item.perContact }} / {{ suggestion.item.nric }}</span>
        </template>
      </vue-autosuggest>
    </b-form-group> -->
    <div class="d-flex justify-content-between gap-3 mt-2">
      <b-button
        variant="outline-primary"
        class="mr-1 w-50"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        class="w-50"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import { VueAutosuggest } from 'vue-autosuggest'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
    // VueAutosuggest,
  },
  props: {
    receiptStatusFilter: {
      type: [Array, null],
      default: () => [],
    },
    paymentModeFilter: {
      type: [Array, null],
      default: () => [],
    },
    fileTypeFilter: {
      type: [Array, null],
      default: () => [],
    },
    customerFilter: {
      type: [String, Number, null],
      default: '',
    },
    customerName: {
      type: [String, null],
      default: null,
    },
    trxDateFilter: {
      type: [String, null],
      default: null,
    },
    receiptStatusOptions: {
      type: Array,
      default: () => [],
    },
    paymentModeOptions: {
      type: Array,
      default: () => [],
    },
    productOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      trxDateFilterValue: this.trxDateFilter,
      customerFilterValue: this.customerFilter,
      receiptStatusFilterValue: JSON.parse(JSON.stringify(this.receiptStatusFilter)) || [],
      fileTypeFilterValue: JSON.parse(JSON.stringify(this.fileTypeFilter)) || [],
      paymentModeFilterValue: JSON.parse(JSON.stringify(this.paymentModeFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
      query: '',
      inputProps: {
        id: 'autosuggest__input_ajax',
        placeholder: 'Search Customer Name, NRIC, Mobile No. or Email',
        class: 'form-control',
        name: 'ajax',
      },
      suggestions: [],
      debounceMilliseconds: 1000,
    }
  },
  watch: {
    trxDateFilter: {
      immediate: true,
      handler(val) {
        this.trxDateFilterValue = val
      },
    },
    customerFilter: {
      immediate: true,
      handler(val) {
        this.customerFilterValue = val
      },
    },
    receiptStatusFilter: {
      immediate: true,
      handler(val) {
        this.receiptStatusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    fileTypeFilter: {
      immediate: true,
      handler(val) {
        this.fileTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    paymentModeFilter: {
      immediate: true,
      handler(val) {
        this.paymentModeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.trxDateFilterValue) {
        this.$emit('emitShowFilter')
      }
    },

    applyFilter() {
      this.$emit('update:trxDateFilter', this.trxDateFilterValue)
      this.$emit('update:customerFilter', this.customerFilterValue)
      this.$emit('update:receiptStatusFilter', this.receiptStatusFilterValue)
      this.$emit('update:paymentModeFilter', this.paymentModeFilterValue)
      this.$emit('update:fileTypeFilter', this.fileTypeFilterValue)
      this.$emit('update:customerName', this.query)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.trxDateFilterValue = ''
      this.customerFilterValue = ''
      this.receiptStatusFilterValue = []
      this.paymentModeFilterValue = []
      this.fileTypeFilterValue = []
      this.$emit('update:trxDateFilter', this.trxDateFilterValue)
      this.$emit('update:customerFilter', this.customerFilterValue)
      this.$emit('update:receiptStatusFilter', this.receiptStatusFilterValue)
      this.$emit('update:paymentModeFilter', this.paymentModeFilterValue)
      this.$emit('update:fileTypeFilter', this.fileTypeFilterValue)
      this.$emit('update:customerName', '')

      this.$emit('emitHideFilter')
    },
    getSuggestionValue(suggestion) {
      const { item } = suggestion
      return item.name
    },

    setCustomer(suggestion) {
      this.query = suggestion.item.name
      this.customerFilterValue = suggestion.item.entityID
    },
    fetchResults() {
      const { query } = this

      if (query && query.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$http.get('appointment/bookings/respond-with/customers', { params: { search: query } })
            .then(response => {
              if (response.data.customers.length === 0) {
                this.suggestions = []
              } else {
                this.suggestions = [{
                  data: response.data.customers,
                }]
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }, this.debounceMilliseconds)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
